import React from "react";
import FacebookAccountSelector from "@/components/organisms/FacebookAccountSelector";
import ApperIcon from "@/components/ApperIcon";

function Header() {
  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center space-x-2">
          <div className="bg-gradient-to-r from-facebook to-facebook-hover rounded-lg p-2">
            <ApperIcon name="Zap" className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">Ratesight FB Ads AI</h1>
            <p className="text-xs text-gray-500">Manage campaigns, audiences, and creatives.</p>
          </div>
        </div>

        <div className="w-full lg:w-auto">
          <FacebookAccountSelector />
        </div>
      </div>
    </header>
  );
}

export default Header;
